import { flagFactory } from '../icon';
import Svg from './gr.svg';

export default flagFactory(Svg);
